import { cf2imgix } from '@uswitch/ev-components/lib/components/elements/imgix-img'

const getAuthorDetails = (includes, embeddedEeveeEntityIds) => {
  if (!embeddedEeveeEntityIds) return {}

  const author = {
    ...includes[embeddedEeveeEntityIds?.author]?.fields
  }

  return {
    ...author,
    image: cf2imgix(`https:${includes[author?.image?.sys?.id]?.fields?.file?.url}`)
  }
}

export default getAuthorDetails
